import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import aboutme from '../assets/aboutme.png';

const About = () => {
  return (
      <div>
      
      <div class="container">
        <div class="row">
          <div class="col-xs-10.25 col-md-8 col-lg-10">
            <div class="white-box">
              <h1 class="aboutme">About Me</h1>
              <div><img class="pt-2 pr-2 float-left" alt="About Me" src={aboutme}></img></div>
                <p>Hello! My name is Sydney and I am an aspiring web developer. Over the past five months I've spent my time learning the ins and outs of fullstack development, UI design, and how to piece together a variety of different applications. I am constantly learning and asking questions, and I believe that my education with coding will go far beyond the scope of my bootcamp. Before enrolling in the Coding Bootcamp through the University of Utah I had no coding experience. I am proud of how far I have come in the short time that I've been learning. When I entered the bootcamp, I had no idea what to expect! But I soon learned that my familiarity with software and computers would be to my advantage. HTML and CSS came naturally to me. As an artist, using programs based around design is something I'm very familiar with. Four and a half months in, I feel I'm understanding JavaScript more and more, and as we dive into databases I'm learning to really enjoy back-end development as well! Currently, I work full time as a video editor for a travel website. Film and Video have been my career focus for over a decade. I would love to learn more about writing scripts for After Effects and how to build editing softwares in general. Feel free to check out my portfolio to get a taste of the projects I've been working on, or visit my contact page if you would like to reach out to me!</p>
            </div>
          </div>
        </div>
      </div>

      </div>
    
    );

  }


export default About;